import { TrancheDto } from './TrancheDto';

export class HaircutDto {
  currency: string;
  description?: string;
  classification?: string;
  tranches: Array<TrancheDto>;
}
